import script from "./ManageShare.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageShare.vue?vue&type=script&setup=true&lang=js"

import "./ManageShare.vue?vue&type=style&index=0&id=ef37a0a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef37a0a6"]])

export default __exports__